// extracted by mini-css-extract-plugin
export default {"qrCode":"enable-totp-modal_qrCode__HPQkL"};